<template>
  <div class="custom-collection-content md:flex align-items-center">
    <h2 v-if="title">
      {{ title }}
    </h2>
    <p 
      v-if="description" 
      class="custom-desc"
    >
      {{ description }}
    </p>
    <div class="collection-carousels__buttons flex custom-btn">
      <button
        v-for="carousel, index in carousels"
        :key="`carousel-btn-${index}`"
        class="collection-carousel__button"
        :class="{ 'collection-carousel__button--active': carousel.collectionHandle === activeCarousel.collectionHandle }"
        @click="changeCarousel(index)"
      >
        {{ carousel.title }}
      </button>
    </div>
    <a
      :href="`/collections/${activeCarousel.collectionHandle}`"
      class="collection-carousels__cta btn custom-cta-button desktop"
    >
      {{ activeCarousel.ctaText || ctaText || "Shop now" }}
    </a>
  </div>
  <div class="custom-collection-products">
    <vue-flickity
      :key="activeCarousel.collectionHandle"
      ref="carousel"
      class="collection-carousels__carousel"
      :options="{
        'prevNextButtons': true,
        'pageDots': false,
        'cellAlign': 'left'
      }"
    >
      <ProductItem
        v-for="product in activeCarousel.collectionProducts"
        :key="product.handle"
        :product="product"
      />
    </vue-flickity>
  </div>
  <a
      :href="`/collections/${activeCarousel.collectionHandle}`"
      class="collection-carousels__cta btn custom-cta-button mobile"
    >
      {{ activeCarousel.ctaText || ctaText || "Shop now" }}
    </a>
</template>

<script>

import ProductItem from './product-item'

export default {
  components: {
    ProductItem
  },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default:null
    },
    carousels: {
      type: Array,
      default: null
    },
    ctaText: { 
      type: String,
      default: "Shop now"
    },
    
  },
  data () {
    return {
      activeCarousel: { ...this.carousels[0] }
    }
  },
  mounted () {

  },
  methods: {
    changeCarousel(index) {
      this.activeCarousel = this.carousels[index]
      // this.$refs.carousel.destroy()
    }
  }
}
</script>
